(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["splendor-embalagem"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runtimeKey = '__splendorPackScrollV1';

    if (window[runtimeKey]) {
      window[runtimeKey].requestUpdate();
      return;
    }

    let frameRequested = false;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const update = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const revealStart = viewportHeight * 0.96;
      const revealEnd = viewportHeight * 0.58;

      document.querySelectorAll('[data-spx-pack-section]').forEach((section) => {
        const copy = section.querySelector('[data-pack-reveal]');
        if (!copy) return;

        section.classList.add('is-motion-ready');

        const rect = copy.getBoundingClientRect();
        const rawProgress = (revealStart - rect.top) / (revealStart - revealEnd);
        const progress = clamp(rawProgress, 0, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const distance = parseFloat(
          window.getComputedStyle(section).getPropertyValue('--pack-distance')
        ) || 80;
        const remaining = 1 - eased;

        copy.style.setProperty('--pack-opacity', eased.toFixed(3));
        copy.style.setProperty('--pack-progress', eased.toFixed(3));
        copy.style.setProperty('--pack-reveal-y', `${(distance * remaining).toFixed(2)}px`);
        copy.style.setProperty('--pack-reveal-x', `${(-distance * 0.22 * remaining).toFixed(2)}px`);
      });

      frameRequested = false;
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:section:select', requestUpdate);

    window[runtimeKey] = { requestUpdate };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', requestUpdate, { once: true });
    } else {
      requestUpdate();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splendor-fecho"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runtimeKey = '__splendorCloseV2';

    const removeShippingWidgets = (section) => {
      section.querySelectorAll(
        '.florss-free-shipping, [data-florss-free-shipping], [class*="free-shipping"], [class*="frete-gratis"]'
      ).forEach((element) => element.remove());
    };

    const bind = (root = document) => {
      const stickyBar = document.querySelector('[data-florss-sticky-atc-layout]');

      if (stickyBar && !stickyBar.dataset.splendorScrollBound) {
        stickyBar.dataset.splendorScrollBound = 'true';
        stickyBar.setAttribute('aria-hidden', 'true');

        const footer = document.querySelector('footer, [data-florss-footer]');
        let ticking = false;

        const updateStickyVisibility = () => {
          const threshold = Math.min(260, Math.max(180, window.innerHeight * .28));
          let shouldShow = window.scrollY > threshold;

          if (footer) {
            const footerRect = footer.getBoundingClientRect();
            if (footerRect.top < window.innerHeight - 8) shouldShow = false;
          }

          stickyBar.classList.toggle('is-visible', shouldShow);
          stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          document.body.classList.toggle('florss-sticky-atc-visible', shouldShow);
        };

        const requestStickyUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            updateStickyVisibility();
            ticking = false;
          });
        };

        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
        updateStickyVisibility();
      }

      root.querySelectorAll('[data-spx-close-section]').forEach((section) => {
        removeShippingWidgets(section);

        if (!section.dataset.closeObserverBound) {
          const observer = new MutationObserver(() => removeShippingWidgets(section));
          observer.observe(section, { childList: true, subtree: true });
          section.dataset.closeObserverBound = 'true';
        }

        const button = section.querySelector('[data-spx-close-add]');
        if (!button) return;

        const stickyButton = document.querySelector(
          '[data-florss-sticky-atc-layout] [data-florss-sticky-atc-button]'
        );

        const resetPurchaseButtons = () => {
          button.disabled = false;
          button.removeAttribute('aria-busy');

          if (stickyButton) {
            stickyButton.disabled = false;
            stickyButton.removeAttribute('aria-busy');
          }
        };

        if (!button.dataset.closeResetBound) {
          button.dataset.closeResetBound = 'true';

          /*
           * O Safari/Chrome mobile pode restaurar a pagina pelo bfcache e
           * manter o botao desabilitado depois que o cliente volta do carrinho.
           */
          window.addEventListener('pageshow', resetPurchaseButtons);
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') resetPurchaseButtons();
          });
        }

        if (button.dataset.closeAddBound) return;

        button.dataset.closeAddBound = 'true';
        button.addEventListener('click', async () => {
          const variantId = Number(button.dataset.variantId);
          if (!variantId || button.disabled) return;

          button.disabled = true;
          button.setAttribute('aria-busy', 'true');

          const rootPath = window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : '/';

          try {
            const response = await fetch(`${rootPath}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
              })
            });

            if (!response.ok) throw new Error('Não foi possível adicionar o produto.');
            resetPurchaseButtons();
            window.location.assign(`${rootPath}cart`);
          } catch (error) {
            resetPurchaseButtons();
          }
        });

        if (stickyButton && !stickyButton.dataset.splendorAddBound) {
          stickyButton.dataset.splendorAddBound = 'true';
          stickyButton.addEventListener('click', (event) => {
            event.preventDefault();
            button.click();
          });
        }
      });
    };

    if (!window[runtimeKey]) {
      window[runtimeKey] = { bind };
      document.addEventListener('shopify:section:load', (event) => bind(event.target));

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
      } else {
        bind();
      }
    } else {
      window[runtimeKey].bind();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splendor-origem"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runtimeKey = '__splendorOriginScrollV1';

    if (window[runtimeKey]) {
      window[runtimeKey].requestUpdate();
      return;
    }

    let frameRequested = false;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const update = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const revealStart = viewportHeight * 0.96;
      const revealEnd = viewportHeight * 0.57;

      document.querySelectorAll('[data-spx-origin-section]').forEach((section) => {
        section.classList.add('is-motion-ready');

        const styles = window.getComputedStyle(section);
        const distance = parseFloat(styles.getPropertyValue('--origin-distance')) || 70;

        section.querySelectorAll('[data-origin-reveal]').forEach((element) => {
          const rect = element.getBoundingClientRect();
          const rawProgress = (revealStart - rect.top) / (revealStart - revealEnd);
          const progress = clamp(rawProgress, 0, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const direction = Number(element.dataset.originDirection || 0);
          const remaining = 1 - eased;
          const translateY = distance * remaining;
          const translateX = distance * 0.32 * direction * remaining;

          element.style.setProperty('--origin-opacity', eased.toFixed(3));
          element.style.setProperty('--origin-reveal-y', `${translateY.toFixed(2)}px`);
          element.style.setProperty('--origin-reveal-x', `${translateX.toFixed(2)}px`);
        });
      });

      frameRequested = false;
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:block:select', requestUpdate);

    window[runtimeKey] = { requestUpdate };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', requestUpdate, { once: true });
    } else {
      requestUpdate();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splendor-ritual"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runtimeKey = '__splendorRitual3dV1';

    if (window[runtimeKey]) {
      window[runtimeKey].requestUpdate();
      return;
    }

    let frameRequested = false;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const update = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      document.querySelectorAll('[data-spx-ritual-section]').forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionProgress = clamp(
          (viewportHeight - rect.top) / (viewportHeight + rect.height),
          0,
          1
        );
        const centeredProgress = sectionProgress - 0.5;
        const styles = window.getComputedStyle(section);
        const parallaxDistance = parseFloat(styles.getPropertyValue('--ritual-parallax')) || 50;
        const tiltIntensity = parseFloat(styles.getPropertyValue('--ritual-tilt')) || 7;

        section.style.setProperty(
          '--ritual-image-y',
          `${(-centeredProgress * parallaxDistance).toFixed(2)}px`
        );
        section.style.setProperty(
          '--ritual-rotate-x',
          `${(1.5 + centeredProgress * tiltIntensity * 0.42).toFixed(2)}deg`
        );
        section.style.setProperty(
          '--ritual-rotate-y',
          `${(-tiltIntensity + centeredProgress * tiltIntensity * 0.72).toFixed(2)}deg`
        );

        section.classList.add('is-motion-ready');

        const revealStart = viewportHeight * 0.96;
        const revealEnd = viewportHeight * 0.64;

        section.querySelectorAll('[data-ritual-reveal]').forEach((element, index) => {
          const elementRect = element.getBoundingClientRect();
          const delayedTop = elementRect.top + index * 16;
          const rawProgress = (revealStart - delayedTop) / (revealStart - revealEnd);
          const progress = clamp(rawProgress, 0, 1);
          const eased = 1 - Math.pow(1 - progress, 3);

          element.style.setProperty('--ritual-reveal-opacity', eased.toFixed(3));
          element.style.setProperty('--ritual-reveal-y', `${((1 - eased) * 48).toFixed(2)}px`);
        });
      });

      frameRequested = false;
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:block:select', requestUpdate);

    window[runtimeKey] = { requestUpdate };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', requestUpdate, { once: true });
    } else {
      requestUpdate();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
